<ng-container *ngIf="!!candidate">
  <ng-container *ngFor="let el of getOrderedDocs()">
    <app-text-separator text="{{el?.category}}" innerClass="mt-px-32 mb-px-32"></app-text-separator>
    <div class="d-flex  flex-column gap-4">
      <ng-container *ngFor="let doc of el?.docs">
        <span class="cursor-pointer" (click)="download(doc.attr)">{{ doc.label }}</span>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
